import { ActionsPlanTypes } from 'legacy/lut/classes/helpers/partner360/usePartnerInfo'
import { TInvestmentSourceValue } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/commonComponents/editorComponents/components/investmentSource/models'
import { IFormKIEditor } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/models'
import { KeyInitiativeInitTypes as LegacyInitTypes } from 'legacy/lut/components/widgets/public/partner360/actionsPlan/keyInitiatives/models/keyInitiativeInitTypes'

import { KeyInitiative } from 'partner360/entities/keyInitiatives'
import { normalizeKeyInitiativeStatus } from 'partner360/entities/keyInitiatives/model/status'
import { KeyInitiativeInitTypes } from 'partner360/entities/keyInitiatives/model/types'

export const mapPreviousYearInitiativeToEditorState = (
  initiative: KeyInitiative
): Partial<IFormKIEditor> => {
  const { HPInvestmentSource, InitType, ...fields } = initiative
  const investmentSources: Record<string, TInvestmentSourceValue> = {
    Opex: ActionsPlanTypes.Opex,
    MDF: ActionsPlanTypes.MDF,
    DGF: ActionsPlanTypes.DGF,
    'Alliance Funds': 'Alliance Funds',
  }

  return {
    ...fields,
    Name: initiative.Name ?? '',
    Comment: initiative.Comment ?? '',
    Development: initiative.Development ?? '',
    Status: normalizeKeyInitiativeStatus(initiative.Status),
    Category: initiative.Category ?? '',
    HPInvestmentSource: HPInvestmentSource ? (investmentSources[HPInvestmentSource] ?? null) : null,
    InitType:
      InitType === KeyInitiativeInitTypes.ImportedInitiative
        ? LegacyInitTypes.ImportedInitiative
        : null,
  }
}
